<template>
  <div class="flex text-white text-sm">
    <button
      v-for="(item, index) in items"
      :key="item.key ?? `${index}-${item.label}`"
      type="button"
      class="flex items-center h-9 px-2 hover:bg-blue-900 cursor-pointer border-r-2 border-primary-800"
      :class="{
        'rounded-l-lg': index === 0,
        'rounded-r-lg': index === items.length - 1,
        'bg-blue-800': isActive(item, index),
        'bg-blue-600': !isActive(item, index),
      }"
      @click="selectItem(item, index)"
    >
      <i class="fa-solid" :class="[item.icon, item.label ? 'mr-2 mt-1' : '']"></i>
      <span>{{ item.label }}</span>
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: [String, Number],
    default: 0,
  },
  valueField: {
    type: String,
    default: 'value',
  },
})

const emit = defineEmits(['update:modelValue', 'select'])

const getItemValue = (item, index) => {
  return item?.[props.valueField] !== undefined ? item[props.valueField] : index
}

const isActive = (item, index) => props.modelValue === getItemValue(item, index)

const selectItem = (item, index) => {
  const value = getItemValue(item, index)
  emit('update:modelValue', value)
  emit('select', { item, index, value })
}
</script>
